import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadParentTrials: IParentTrialsLoadActionCreator = () => {
        return {
            type: ACTION_PARENT_TRIALS_LOAD
        }
    },
    LoadSuccess: IParentTrialsLoadSuccessActionCreator = (data) => {
        return {
            type: ACTION_PARENT_TRIALS_LOAD_SUCCESS,
            data,
        }
    },
    LoadFailure: IParentTrialsLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PARENT_TRIALS_LOAD_FAILURE,
            responseStatus
        }
    },
    Clear: IParentTrialsClearActionCreator = () => {
        return {
            type: ACTION_PARENT_TRIALS_CLEAR
        }
    };
    

export const
    ACTION_PARENT_TRIALS_LOAD = "ACTION_PARENT_TRIALS_LOAD",
    ACTION_PARENT_TRIALS_LOAD_SUCCESS = "ACTION_PARENT_TRIALS_LOAD_SUCCESS",
    ACTION_PARENT_TRIALS_LOAD_FAILURE = "ACTION_PARENT_TRIALS_LOAD_FAILURE",
    ACTION_PARENT_TRIALS_CLEAR = "ACTION_PARENT_TRIALS_CLEAR";

export interface IParentTrialsLoadAction {
    type: "ACTION_PARENT_TRIALS_LOAD";
}

export interface IParentTrialsLoadActionCreator {
    (): IParentTrialsLoadAction;
}

export interface IParentTrialsLoadSuccessAction {
    type: "ACTION_PARENT_TRIALS_LOAD_SUCCESS";
    data: Dtos.Trial[];
}

export interface IParentTrialsLoadSuccessActionCreator {
    (data: Dtos.Trial[]): IParentTrialsLoadSuccessAction;
}

export interface IParentTrialsLoadFailureAction {
    type: "ACTION_PARENT_TRIALS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IParentTrialsLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IParentTrialsLoadFailureAction;
}

export interface IParentTrialsClearAction {
    type: "ACTION_PARENT_TRIALS_CLEAR";
}

export interface IParentTrialsClearActionCreator {
    (): IParentTrialsClearAction;
}

export type ParentTrialsAction = IParentTrialsLoadAction |
    IParentTrialsLoadFailureAction |
    IParentTrialsLoadSuccessAction |
    IParentTrialsClearAction;
